import React, { Component } from "react";
import { Button, FormControl } from "react-bootstrap";

export default class VerificationItem extends Component {
  render() {
    return (
      <tr>
        <td style={{ width: "10%" }}>
          <FormControl
            type="text"
            placeholder="Barcode"
            className="mb-3"
            value={this.props.item.BarCodeNumber}
            onChange={(e) =>
              this.props.setBarcode(e.target.value, this.props.index)
            }
          />
        </td>
        <td style={{ width: "20%" }}>
          <FormControl
            as="select"
            onChange={(e) =>
              this.props.setUser(e.target.value, this.props.index)
            }
          >
            {this.props.users.map((user, index) => (
              <option
                key={index}
                value={user.id}
                selected={this.props.users.findIndex(
                  (user) => this.props.userId === parseInt(user.id)
                )}
              >
                {user.name}
              </option>
            ))}
          </FormControl>
        </td>

        <td style={{ width: "20%" }}>
          <FormControl
            type="text"
            placeholder="Comment"
            className="mb-3"
            value={this.props.item.comment}
            onChange={(e) =>
              this.props.setComment(e.target.value, this.props.index)
            }
          />
        </td>
        <td style={{ width: "20%" }}>{this.props.department}</td>
        <td style={{ width: "8%" }}>
          <Button
            variant="danger"
            onClick={() => this.props.removeItem(this.props.index)}
          >
            <i className="fa fa-times fa-lg" />
          </Button>
        </td>
      </tr>
    );
  }
}
